import React from "react";
const EmailPreviewPopup = ({ htmlContent }) => {
  if (!htmlContent) return null;
  const supportsSrcDoc = "srcdoc" in document.createElement("iframe");
  const disableClickScript = `
    <script>
      document.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
      }, true);
    </script>`;

  return (
    <div
      style={{
        width: "100%",
        height: "70vh",
        overflow: "auto",
        border: "1px solid #E0DEFA",
        backgroundColor: "#fff",
      }}
    >
      {supportsSrcDoc ? (
        <iframe
          title="Email Preview"
          srcDoc={htmlContent + disableClickScript}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
          }}
        />
      ) : (
        <div
          style={{ width: "100%", height: "100%" }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
          onClickCapture={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        />
      )}
    </div>
  );
};
export default EmailPreviewPopup;